.drawer {
  height: 100%;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-bottom: 90px; /* Reserve space for the absolutely positioned footer */
}

.fieldGrid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  align-items: start;
}

.selectItem {
  width: 100%;
}

.drawerFooter {
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  width: 100%;
  column-gap: 0.5rem;
  border-top: 1px solid var(--color-neutral-200);
  background-color: #fff;
  padding: 1rem 1.5rem;
}

.button {
  width: 100%;
}
